import { gql } from 'graphql.macro';

export const searchFragment = gql`
    fragment searchFields on Search {
        _id
        type
        patient {
            firstName
            lastName
            personalIdentityNumber
        }
        created {
            on
        }
        orderId
        labFlag
        deliveryDetails {
            sample {
                type
            }
        }
        simpleConstructionName
        actionSubCategoryName
        createdDateAndTime
        internalOrderId
    }
`;
